"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _layout = _interopRequireDefault(require("@/layout"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var jhycRouter = {
  path: '/jhyc',
  component: _layout.default,
  redirect: '/jhyc',
  name: 'JhycManager',
  alwaysShow: true,
  meta: {
    title: '巨会养车管理',
    icon: 'clipboard'
  },
  children: [{
    path: '/jhyc/order/index',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/jhyc/order/index'));
      });
    },
    name: 'jhycOrderIndex',
    meta: {
      title: '核销订单'
    }
  }, {
    path: '/jhyc/reservation/order/index',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/jhyc/reservation/index'));
      });
    },
    name: 'jhycReservationOrderIndex',
    meta: {
      title: '预约订单'
    }
  }, {
    path: '/service/index',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/jhyc/service/index'));
      });
    },
    name: 'jhycServiceIndex',
    meta: {
      title: '产品服务'
    }
  }, {
    path: '/store/index',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/jhyc/store/index'));
      });
    },
    name: 'jhycStoreIndex',
    meta: {
      title: '门店管理'
    }
  }]
};
var _default = exports.default = jhycRouter;